import { Box } from "@chakra-ui/react";
import DocViewer from "@cyntler/react-doc-viewer";
import { DocViewerRenderers } from "@cyntler/react-doc-viewer/dist/esm/renderers";
import { useAppSelector } from "redux/hooks";
import { selectCurrentCourse } from "redux/slices/currentCourseSlice";
export default function CourseViewer() {
  const { currCourse } = useAppSelector(selectCurrentCourse);
  console.log({ currCourse });
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <DocViewer
        onDocumentChange={(doc) => console.log({ doc })}
        pluginRenderers={DocViewerRenderers}
        prefetchMethod="GET"
        style={{ width: "100%", height: "100%" }}
        documents={[{ uri: currCourse.ressource }]}
      />
    </Box>
  );
}
